
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { list_type, record_type, string_type, union_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { comparePrimitives, createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { singleton as singleton_1, map, append as append_1, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { IconDownload, IconUpload, IconCalendar, IconCheckmark, IconDatabase, IconSparkles, IconArrowRight } from "../Components/Icon.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { ofList, FSharpSet__Contains } from "../fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { join, concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { TextButton, Button } from "../Components/Button.js";
import { Msg } from "./Types.js";
import { RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { DemoDataImportDialog } from "../Widgets/Dialogs/DemoDataImportDialog.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { Dialog } from "../Components/Dialog.js";
import { Skeleton } from "../Components/Skeleton.js";

const accent = "#15B897";

const accentSoft = "#E4F7F2";

const accentInk = "#0B7A65";

const textMuted = "#6B7280";

const textSubtle = "#98A0A8";

const borderColor = "#E6E8EB";

const surface = "#FFFFFF";

export class OnboardingChoice extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ImportOwnData", "StartTour"];
    }
}

export function OnboardingChoice_$reflection() {
    return union_type("OnboardingHub.View.OnboardingChoice", [], OnboardingChoice, () => [[], []]);
}

function cardMeta(iconEl, text) {
    let elems;
    return reactElement("div", createObj(ofArray([["style", {
        fontSize: 12 + "px",
        color: textSubtle,
        display: "flex",
        alignItems: "center",
        gap: 6 + "px ",
    }], (elems = [iconEl, reactElement("span", {
        children: [text],
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function cardFooterArrow(label) {
    let elems;
    return reactElement("span", createObj(ofArray([["style", {
        color: accent,
        fontWeight: 600,
        display: "inline-flex",
        alignItems: "center",
        gap: 4 + "px ",
        fontSize: 13 + "px",
    }], (elems = [label, IconArrowRight(13)], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function DemoCard(props) {
    let elems_3, elems, elems_1, elems_2;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setHovered = patternInput_1[1];
    const hovered = patternInput_1[0];
    const interactive = !props.Disabled;
    return reactElement("button", createObj(ofArray([["data-test-id", "onboarding-hub-demo-card"], ["onMouseEnter", (_arg) => {
        if (interactive) {
            setHovered(true);
        }
    }], ["onMouseLeave", (_arg_1) => {
        setHovered(false);
    }], ["onClick", (_arg_2) => {
        if (interactive) {
            props.OnOpenDialog();
        }
    }], ["disabled", props.Disabled], ["style", {
        backgroundImage: "linear-gradient(140deg, #F3FAF8 0%, #E4F7F2 100%)",
        border: (((1 + "px ") + "solid") + " ") + ((hovered && interactive) ? accent : "#BEE4DA"),
        borderRadius: 14,
        padding: 24,
        display: "flex",
        flexDirection: "column",
        gap: 14 + "px ",
        minHeight: 360,
        cursor: interactive ? "pointer" : "not-allowed",
        textAlign: "left",
        position: "relative",
        overflow: "hidden",
        opacity: props.Disabled ? 0.5 : 1,
        transform: (hovered && interactive) ? "translateY(-2px)" : "translateY(0)",
        "box-shadow": (hovered && interactive) ? "0 8px 28px rgba(21,184,151,.12)" : "none",
        transition: "all 0.2s ease",
    }], (elems_3 = [reactElement("div", createObj(ofArray([["style", {
        display: "inline-flex",
        alignItems: "center",
        gap: 4 + "px ",
        fontSize: 11 + "px",
        fontWeight: 600,
        textTransform: "uppercase",
        "letter-spacing": "0.06em",
        color: accentInk,
        backgroundColor: accentSoft,
        padding: ((4 + "px") + " ") + (8 + "px"),
        borderRadius: 999,
        width: "fit-content",
    }], (elems = [IconSparkles(11), reactElement("span", {
        children: [t("onboarding.hub.demo_card_badge")],
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["style", {
        width: 52,
        height: 52,
        borderRadius: 12,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: accent,
        color: surface,
        marginBottom: 4,
    }], (elems_1 = [IconDatabase(22)], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("h3", {
        style: {
            fontSize: 19 + "px",
            fontWeight: 600,
            margin: 0,
            "letter-spacing": "-0.01em",
            color: "#14181B",
        },
        children: t("onboarding.hub.demo_card_title"),
    }), reactElement("p", {
        style: {
            color: textMuted,
            fontSize: 13.5 + "px",
            lineHeight: 1.5,
            margin: 0,
            flexGrow: 1,
        },
        children: t("onboarding.hub.demo_card_description"),
    }), cardMeta(IconCheckmark(12), t("onboarding.hub.demo_card_meta")), reactElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingTop: 10,
        borderTop: (((1 + "px ") + "solid") + " ") + borderColor,
    }], (elems_2 = [reactElement("span", {
        style: {
            fontSize: 12 + "px",
            color: textMuted,
        },
        children: t("onboarding.hub.demo_card_footer_left"),
    }), cardFooterArrow(t("onboarding.hub.demo_card_footer_right"))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function OptionCard(props) {
    let elems_2, elems, elems_1;
    const patternInput = reactApi.useState(false);
    const setHovered = patternInput[1];
    const hovered = patternInput[0];
    return reactElement("button", createObj(ofArray([["data-test-id", props.TestId], ["onMouseEnter", (_arg) => {
        setHovered(true);
    }], ["onMouseLeave", (_arg_1) => {
        setHovered(false);
    }], ["onClick", (_arg_2) => {
        props.OnClick();
    }], ["style", {
        backgroundColor: surface,
        border: (((1 + "px ") + "solid") + " ") + (hovered ? accent : borderColor),
        borderRadius: 14,
        padding: 24,
        display: "flex",
        flexDirection: "column",
        gap: 14 + "px ",
        minHeight: 360,
        cursor: "pointer",
        textAlign: "left",
        position: "relative",
        overflow: "hidden",
        transform: hovered ? "translateY(-2px)" : "translateY(0)",
        "box-shadow": hovered ? "0 8px 28px rgba(21,184,151,.12)" : "none",
        transition: "all 0.2s ease",
    }], (elems_2 = [reactElement("div", createObj(ofArray([["style", {
        width: 52,
        height: 52,
        borderRadius: 12,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: accentSoft,
        color: accentInk,
        marginBottom: 4,
    }], (elems = [props.Icon(22)], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("h3", {
        style: {
            fontSize: 19 + "px",
            fontWeight: 600,
            margin: 0,
            "letter-spacing": "-0.01em",
            color: "#14181B",
        },
        children: props.Title,
    }), reactElement("p", {
        style: {
            color: textMuted,
            fontSize: 13.5 + "px",
            lineHeight: 1.5,
            margin: 0,
            flexGrow: 1,
        },
        children: props.Description,
    }), cardMeta(props.MetaIcon(12), props.MetaText), reactElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingTop: 10,
        borderTop: (((1 + "px ") + "solid") + " ") + borderColor,
    }], (elems_1 = [reactElement("span", {
        style: {
            fontSize: 12 + "px",
            color: textMuted,
        },
        children: props.FooterLeft,
    }), cardFooterArrow(props.FooterRight)], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

class TourStep extends Record {
    constructor(Id, Title) {
        super();
        this.Id = Id;
        this.Title = Title;
    }
}

function TourStep_$reflection() {
    return record_type("OnboardingHub.View.TourStep", [], TourStep, () => [["Id", string_type], ["Title", string_type]]);
}

class TourSection extends Record {
    constructor(Id, Tier, TierColor, Title, TierLabel, Steps) {
        super();
        this.Id = Id;
        this.Tier = Tier;
        this.TierColor = TierColor;
        this.Title = Title;
        this.TierLabel = TierLabel;
        this.Steps = Steps;
    }
}

function TourSection_$reflection() {
    return record_type("OnboardingHub.View.TourSection", [], TourSection, () => [["Id", string_type], ["Tier", string_type], ["TierColor", string_type], ["Title", string_type], ["TierLabel", string_type], ["Steps", list_type(TourStep_$reflection())]]);
}

function tourSections(t) {
    return ofArray([new TourSection("starter", t("onboarding.hub.tour_starter_tier"), accentInk, t("onboarding.hub.tour_starter_title"), t("onboarding.hub.tour_starter_label"), ofArray([new TourStep("create-inventory-step", t("onboarding.hub.tour_starter_step_1")), new TourStep("assign-tools-step", t("onboarding.hub.tour_starter_step_2")), new TourStep("who-has-what-step", t("onboarding.hub.tour_starter_step_3")), new TourStep("filter-search-step", t("onboarding.hub.tour_starter_step_4")), new TourStep("inspection-step", t("onboarding.hub.tour_starter_step_5")), new TourStep("category-labels-step", t("onboarding.hub.tour_starter_step_6")), new TourStep("manage-storages-step", t("onboarding.hub.tour_starter_step_7"))])), new TourSection("growth", t("onboarding.hub.tour_growth_tier"), "#7C3AED", t("onboarding.hub.tour_growth_title"), t("onboarding.hub.tour_growth_label"), ofArray([new TourStep("stocktaking-step", t("onboarding.hub.tour_growth_step_1")), new TourStep("set-bundles-step", t("onboarding.hub.tour_growth_step_2")), new TourStep("chat-step", t("onboarding.hub.tour_growth_step_3")), new TourStep("custom-fields-step", t("onboarding.hub.tour_growth_step_4"))])), new TourSection("enterprise", t("onboarding.hub.tour_enterprise_tier"), "#B45309", t("onboarding.hub.tour_enterprise_title"), t("onboarding.hub.tour_enterprise_label"), ofArray([new TourStep("business-units-step", t("onboarding.hub.tour_enterprise_step_1")), new TourStep("api-integrations-step", t("onboarding.hub.tour_enterprise_step_2")), new TourStep("tenants-step", t("onboarding.hub.tour_enterprise_step_3"))]))]);
}

function tourStep(step, completedStepIds, dispatch, t) {
    let elems_1;
    const isDone = FSharpSet__Contains(completedStepIds, step.Id);
    return reactElement("div", createObj(ofArray([["key", step.Id], ["data-test-id", concat("onboarding-tour-step-", ...step.Id)], ["data-completed", isDone ? "true" : "false"], ["style", {
        display: "flex",
        alignItems: "center",
        gap: 10 + "px ",
        padding: ((8 + "px ") + 0) + "px",
        borderBottom: (((1 + "px ") + "solid") + " ") + borderColor,
    }], (elems_1 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["style", createObj(append_1(ofArray([["width", 18], ["height", 18], ["borderRadius", 999], ["flexShrink", 0]]), isDone ? ofArray([["border", (((0 + "px ") + "none") + " ") + borderColor], ["backgroundColor", accent], ["display", "flex"], ["alignItems", "center"], ["justifyContent", "center"], ["color", surface]]) : ofArray([["border", concat("1.5px solid ", ...borderColor)], ["backgroundColor", surface]])))], (elems = toList(delay(() => (isDone ? singleton(IconCheckmark(12)) : empty()))), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append(singleton(reactElement("span", {
            style: {
                fontSize: 13 + "px",
                color: "#14181B",
                flexGrow: 1,
            },
            children: step.Title,
        })), delay(() => ((step.Id === "create-inventory-step") ? singleton(createElement(Button, {
            ComponentState: "enabled",
            Label: t("onboarding.hub.tour_start_step"),
            OnClick: () => {
                dispatch(new Msg(3, [step.Id]));
            },
            TestId: "onboarding-tour-start-create-inventory",
            Variant: "primary",
        })) : ((step.Id === "assign-tools-step") ? singleton(createElement(Button, {
            ComponentState: "enabled",
            Label: t("onboarding.hub.tour_start_step"),
            OnClick: () => {
                dispatch(new Msg(3, [step.Id]));
            },
            TestId: "onboarding-tour-start-assign-inventory",
            Variant: "primary",
        })) : ((step.Id === "who-has-what-step") ? singleton(createElement(Button, {
            ComponentState: "enabled",
            Label: t("onboarding.hub.tour_start_step"),
            OnClick: () => {
                dispatch(new Msg(3, [step.Id]));
            },
            TestId: "onboarding-tour-start-who-has-what",
            Variant: "primary",
        })) : ((step.Id === "filter-search-step") ? singleton(createElement(Button, {
            ComponentState: "enabled",
            Label: t("onboarding.hub.tour_start_step"),
            OnClick: () => {
                dispatch(new Msg(3, [step.Id]));
            },
            TestId: "onboarding-tour-start-filter-search",
            Variant: "primary",
        })) : ((step.Id === "inspection-step") ? singleton(createElement(Button, {
            ComponentState: "enabled",
            Label: t("onboarding.hub.tour_start_step"),
            OnClick: () => {
                dispatch(new Msg(3, [step.Id]));
            },
            TestId: "onboarding-tour-start-inspection",
            Variant: "primary",
        })) : ((step.Id === "category-labels-step") ? singleton(createElement(Button, {
            ComponentState: "enabled",
            Label: t("onboarding.hub.tour_start_step"),
            OnClick: () => {
                dispatch(new Msg(3, [step.Id]));
            },
            TestId: "onboarding-tour-start-category-labels",
            Variant: "primary",
        })) : ((step.Id === "manage-storages-step") ? singleton(createElement(Button, {
            ComponentState: "enabled",
            Label: t("onboarding.hub.tour_start_step"),
            OnClick: () => {
                dispatch(new Msg(3, [step.Id]));
            },
            TestId: "onboarding-tour-start-manage-storages",
            Variant: "primary",
        })) : ((step.Id === "tenants-step") ? singleton(createElement(Button, {
            ComponentState: "enabled",
            Label: t("onboarding.hub.tour_start_step"),
            OnClick: () => {
                dispatch(new Msg(3, [step.Id]));
            },
            TestId: "onboarding-tour-start-tenants",
            Variant: "primary",
        })) : ((step.Id === "chat-step") ? singleton(createElement(Button, {
            ComponentState: "enabled",
            Label: t("onboarding.hub.tour_start_step"),
            OnClick: () => {
                dispatch(new Msg(3, [step.Id]));
            },
            TestId: "onboarding-tour-start-chat",
            Variant: "primary",
        })) : ((step.Id === "api-integrations-step") ? singleton(createElement(Button, {
            ComponentState: "enabled",
            Label: t("onboarding.hub.tour_start_step"),
            OnClick: () => {
                dispatch(new Msg(3, [step.Id]));
            },
            TestId: "onboarding-tour-start-rest-api",
            Variant: "primary",
        })) : ((step.Id === "business-units-step") ? singleton(createElement(Button, {
            ComponentState: "enabled",
            Label: t("onboarding.hub.tour_start_step"),
            OnClick: () => {
                dispatch(new Msg(3, [step.Id]));
            },
            TestId: "onboarding-tour-start-business-units",
            Variant: "primary",
        })) : ((step.Id === "set-bundles-step") ? singleton(createElement(Button, {
            ComponentState: "enabled",
            Label: t("onboarding.hub.tour_start_step"),
            OnClick: () => {
                dispatch(new Msg(3, [step.Id]));
            },
            TestId: "onboarding-tour-start-set-bundles",
            Variant: "primary",
        })) : ((step.Id === "stocktaking-step") ? singleton(createElement(Button, {
            ComponentState: "enabled",
            Label: t("onboarding.hub.tour_start_step"),
            OnClick: () => {
                dispatch(new Msg(3, [step.Id]));
            },
            TestId: "onboarding-tour-start-stocktaking",
            Variant: "primary",
        })) : ((step.Id === "custom-fields-step") ? singleton(createElement(Button, {
            ComponentState: "enabled",
            Label: t("onboarding.hub.tour_start_step"),
            OnClick: () => {
                dispatch(new Msg(3, [step.Id]));
            },
            TestId: "onboarding-tour-start-custom-fields",
            Variant: "primary",
        })) : empty()))))))))))))))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function sectionCard(section, completedStepIds, dispatch, t) {
    let elems_3, elems_2, elems, elems_1;
    return reactElement("div", createObj(ofArray([["key", section.Id], ["style", {
        padding: 12,
    }], (elems_3 = [reactElement("div", createObj(ofArray([["style", {
        backgroundColor: "#FAFAFA",
        borderRadius: 10,
        padding: ((20 + "px ") + 20) + "px",
        height: 100 + "%",
        border: "1px solid #F4F5F5",
    }], (elems_2 = [reactElement("div", createObj(ofArray([["style", {
        marginBottom: 12,
    }], (elems = [reactElement("span", {
        style: {
            display: "inline-flex",
            alignItems: "center",
            fontSize: 10 + "px",
            fontWeight: 700,
            textTransform: "uppercase",
            "letter-spacing": "0.08em",
            color: section.TierColor,
            background: concat(section.TierColor, ..."18"),
            padding: ((3 + "px ") + 8) + "px",
            borderRadius: 999,
            marginBottom: 8,
        },
        children: section.Tier,
    }), reactElement("div", {
        style: {
            fontSize: 15 + "px",
            fontWeight: 600,
            color: "#14181B",
            marginBottom: 2,
        },
        children: section.Title,
    }), reactElement("div", {
        style: {
            fontSize: 12 + "px",
            color: textSubtle,
        },
        children: section.TierLabel,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(singleton_1((elems_1 = map((s) => tourStep(s, completedStepIds, dispatch, t), section.Steps), ["children", reactApi.Children.toArray(Array.from(elems_1))]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function TourPanel(t, completedStepIds, dispatch) {
    let elems_3, elems_1, elems, elems_2;
    return reactElement("div", createObj(ofArray([["style", {
        marginTop: 40,
        backgroundColor: surface,
        borderRadius: 14,
        overflow: "hidden",
    }], (elems_3 = [reactElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        padding: ((24 + "px ") + 24) + "px",
    }], (elems_1 = [reactElement("div", createObj(singleton_1((elems = [reactElement("h2", {
        style: {
            fontSize: 17 + "px",
            fontWeight: 600,
            color: "#14181B",
            margin: ((((((0 + "px ") + 0) + "px ") + 4) + "px ") + 0) + "px",
            "letter-spacing": "-0.01em",
        },
        children: t("onboarding.hub.tour_panel_title"),
    }), reactElement("p", {
        style: {
            fontSize: 13 + "px",
            color: textMuted,
            margin: 0,
        },
        children: t("onboarding.hub.tour_panel_description"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["style", {
        display: "grid",
        "grid-template-columns": "repeat(3, 1fr)",
    }], (elems_2 = map((s) => sectionCard(s, completedStepIds, dispatch, t), tourSections(t)), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function ContactCard(props) {
    let elems_2, elems, elems_1;
    const patternInput = reactApi.useState(false);
    const setHovered = patternInput[1];
    const hovered = patternInput[0];
    return reactElement("button", createObj(ofArray([["data-test-id", "onboarding-hub-contact-card"], ["onMouseEnter", (_arg) => {
        setHovered(true);
    }], ["onMouseLeave", (_arg_1) => {
        setHovered(false);
    }], ["onClick", (_arg_2) => {
        RouterModule_nav(ofArray(["getting-started", "contact"]), 1, 1);
    }], ["style", {
        backgroundColor: surface,
        border: (((1 + "px ") + "solid") + " ") + (hovered ? accent : borderColor),
        borderRadius: 14,
        padding: 24,
        display: "flex",
        flexDirection: "column",
        gap: 14 + "px ",
        minHeight: 360,
        cursor: "pointer",
        textAlign: "left",
        position: "relative",
        overflow: "hidden",
        transform: hovered ? "translateY(-2px)" : "translateY(0)",
        "box-shadow": hovered ? "0 8px 28px rgba(21,184,151,.12)" : "none",
        transition: "all 0.2s ease",
    }], (elems_2 = [reactElement("div", createObj(ofArray([["style", {
        width: 52,
        height: 52,
        borderRadius: 12,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: accentSoft,
        color: accentInk,
        marginBottom: 4,
    }], (elems = [IconCalendar(22)], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("h3", {
        style: {
            fontSize: 19 + "px",
            fontWeight: 600,
            margin: 0,
            "letter-spacing": "-0.01em",
            color: "#14181B",
        },
        children: props.Title,
    }), reactElement("p", {
        style: {
            color: textMuted,
            fontSize: 13.5 + "px",
            lineHeight: 1.5,
            margin: 0,
            flexGrow: 1,
        },
        children: props.Description,
    }), cardMeta(IconCalendar(12), props.MetaText), reactElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingTop: 10,
        borderTop: (((1 + "px ") + "solid") + " ") + borderColor,
    }], (elems_1 = [reactElement("span", {
        style: {
            fontSize: 12 + "px",
            color: textMuted,
        },
        children: props.FooterLeft,
    }), cardFooterArrow(props.FooterRight)], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function OnboardingHubContent(props) {
    let elems_4, elems_3, elems_1, elems, elems_2, Title, Description, MetaText, Title_1, Description_1, MetaText_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsDialogOpen = patternInput_1[1];
    return reactElement("div", createObj(singleton_1((elems_4 = [createElement(DemoDataImportDialog, {
        IsOpen: patternInput_1[0],
        OnClose: () => {
            setIsDialogOpen(false);
        },
        SuccessCallback: () => {
            document.location.reload(true);
        },
    }), reactElement("div", createObj(ofArray([["style", {
        maxWidth: 1180,
        margin: (0 + "px ") + "auto",
        paddingTop: 28,
    }], (elems_3 = [reactElement("div", createObj(ofArray([["style", {
        marginBottom: 40,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: 32 + "px ",
    }], (elems_1 = [reactElement("div", createObj(singleton_1((elems = [reactElement("div", {
        style: {
            fontSize: 12 + "px",
            fontWeight: 500,
            textTransform: "uppercase",
            "letter-spacing": "0.08em",
            color: accentInk,
            marginBottom: 8,
        },
        children: t("onboarding.hub.label"),
    }), reactElement("h1", {
        style: {
            fontSize: 34 + "px",
            fontWeight: 600,
            margin: ((((((0 + "px ") + 0) + "px ") + 10) + "px ") + 0) + "px",
            "letter-spacing": "-0.02em",
            lineHeight: 1.15,
            color: "#14181B",
        },
        children: t("onboarding.hub.title"),
    }), reactElement("p", {
        style: {
            color: textMuted,
            fontSize: 15 + "px",
            maxWidth: 620,
            margin: 0,
            lineHeight: 1.55,
        },
        children: t("onboarding.hub.subtitle"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["style", {
        display: "grid",
        "grid-template-columns": "repeat(3, 1fr)",
        gap: 20 + "px ",
    }], (elems_2 = [createElement(DemoCard, {
        Disabled: props.DemoCardDisabled,
        OnOpenDialog: () => {
            setIsDialogOpen(true);
        },
    }), createElement(OptionCard, (Title = t("onboarding.hub.import_card_title"), (Description = t("onboarding.hub.import_card_description"), (MetaText = t("onboarding.hub.import_card_meta"), {
        Description: Description,
        FooterLeft: t("onboarding.hub.import_card_footer_left"),
        FooterRight: t("onboarding.hub.import_card_footer_right"),
        Icon: IconUpload,
        MetaIcon: IconDownload,
        MetaText: MetaText,
        OnClick: () => {
            props.OnChoose(new OnboardingChoice(0, []));
        },
        TestId: "onboarding-hub-import-card",
        Title: Title,
    })))), createElement(ContactCard, (Title_1 = t("onboarding.hub.contact_card_title"), (Description_1 = t("onboarding.hub.contact_card_description"), (MetaText_1 = t("onboarding.hub.contact_card_meta"), {
        Description: Description_1,
        FooterLeft: t("onboarding.hub.contact_card_footer_left"),
        FooterRight: t("onboarding.hub.contact_card_footer_right"),
        MetaText: MetaText_1,
        Title: Title_1,
    }))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), TourPanel(t, props.CompletedStepIds, props.Dispatch)], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))]))));
}

export function OnboardingHubView(props) {
    let elems, Title, DemoCardDisabled;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const t = useTranslation()[0];
    const matchValue = state_1.DemoImportAvailable;
    const matchValue_1 = state_1.CompletedTourSteps;
    let matchResult, completedSteps, demoAvail;
    if (matchValue.tag === 1) {
        if (matchValue_1.tag === 1) {
            matchResult = 0;
            completedSteps = matchValue_1.fields[0];
            demoAvail = matchValue.fields[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return reactElement("div", createObj(singleton_1((elems = [createElement(Dialog, (Title = t("onboarding.hub.rest_api_tour_dialog_title"), {
                Body: singleton_1(reactElement("p", {
                    className: join(" ", ["text-sm", "text-text-muted", "leading-relaxed"]),
                    children: t("onboarding.hub.rest_api_tour_dialog_content"),
                })),
                Controls: singleton_1(createElement(TextButton, {
                    ComponentState: "enabled",
                    Label: t("onboarding.hub.rest_api_tour_dialog_button"),
                    OnClick: () => {
                        dispatch(new Msg(6, []));
                    },
                    TestId: "onboarding-rest-api-tour-dialog-close",
                    Variant: "blueButton",
                })),
                IsOpen: state_1.ShowRestApiTourInfoDialog,
                OnClose: () => {
                    dispatch(new Msg(6, []));
                },
                Title: Title,
            })), createElement(OnboardingHubContent, (DemoCardDisabled = !demoAvail, {
                CompletedStepIds: ofList(completedSteps, {
                    Compare: (x, y) => (comparePrimitives(x, y) | 0),
                }),
                DemoCardDisabled: DemoCardDisabled,
                Dispatch: dispatch,
                OnChoose: props.OnChoose,
            }))], ["children", reactApi.Children.toArray(Array.from(elems))]))));
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

